// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__ue_WF","awards-title":"style_awards-title__SC6PN"};